module.exports = __webpack_public_path__ + "img/saba_yes.113d7a35.png";